import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { inr } from "@/lib/api";
import { baseName } from "@/lib/variants";

export default function ProductCard({ product, index = 0, colorCount = 1 }) {
  const img = product.images?.[0];
  const hoverImg = product.images?.[1];
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.65, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link to={`/product/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
        <div className="relative aspect-[3/4] overflow-hidden bg-linen">
          {img && (
            <img
              src={img}
              alt={product.name}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          )}
          {hoverImg && (
            <img
              src={hoverImg}
              alt=""
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100"
            />
          )}
          {product.is_new && (
            <span data-testid="new-badge" className="absolute right-3 top-3 bg-olive px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-bone">
              New
            </span>
          )}
          {product.stock === 0 && (
            <span className="absolute left-3 top-3 bg-obsidian px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-bone">
              Sold Out
            </span>
          )}
        </div>
        <div className="mt-4 flex items-start justify-between gap-4">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-soot">
              {product.subcategory || (product.category === "fashion" ? "Fashion Wear" : "Home Furnishing")}
            </p>
            <h3 className="mt-1 font-serif text-xl leading-tight">{baseName(product.name)}</h3>
            {colorCount > 1 && (
              <p data-testid="color-count" className="mt-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-olive">
                {colorCount} colours
              </p>
            )}
          </div>
          <p className="mt-4 shrink-0 text-sm font-semibold">{inr(product.price)}</p>
        </div>
      </Link>
    </motion.div>
  );
}
